/* DROP theme: collection and search pages (live filters, sort, density, load more, back restores the view) */
(() => {
  const DROP = window.DROP; const { $, $$ } = DROP;
  const ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];

  const init = root => {
    if (!root || root._init) return; root._init = 1;
    const sid = root.dataset.section, isSearch = root.dataset.search === 'true';
    const pageBase = location.pathname;
    const fixed = isSearch ? ['q', 'type', 'options[prefix]'] : [];

    /* sizes in one order: XS S M L XL, then numbers */
    const sortSizes = () => $$('[data-sort-sizes]', root).forEach(box => {
      const items = [...box.children];
      const key = el => { const l = el.querySelector('input')?.dataset.label || ''; const i = ORDER.indexOf(l); return i > -1 ? [0, i] : [1, parseFloat(l) || 999, l]; };
      items.sort((a, b) => { const x = key(a), y = key(b); return x[0] - y[0] || x[1] - y[1] || String(x[2] || '').localeCompare(String(y[2] || '')); }).forEach(el => box.appendChild(el));
    });

    /* Made in Egypt = every Egyptian label in the brand list */
    const syncHg = () => {
      const hg = $('#f-hg', root); if (!hg) return;
      const eg = JSON.parse(hg.dataset.eg || '[]');
      const boxes = $$('[data-param="filter.p.vendor"]', root);
      const egBoxes = boxes.filter(b => JSON.parse(b.dataset.vals).some(v => eg.includes(v)));
      hg.checked = egBoxes.length > 0 && egBoxes.every(b => b.checked) && boxes.filter(b => b.checked).length === egBoxes.length;
    };

    /* carry a single size filter to the product page */
    const syncSize = () => {
      try {
        const on = $$('.sizes-f input:checked', root);
        if (on.length === 1) sessionStorage.setItem('drop-size', on[0].dataset.label); else sessionStorage.removeItem('drop-size');
      } catch (e) { }
    };

    const params = () => {
      const cur = new URLSearchParams(location.search), u = new URLSearchParams();
      fixed.forEach(k => cur.has(k) && u.set(k, cur.get(k)));
      $$('#fbody input[data-vals]:checked', root).forEach(i => JSON.parse(i.dataset.vals).forEach(v => u.append(i.dataset.param, v)));
      $$('#fbody input[data-price]', root).forEach(i => { if (i.value !== '') u.set(i.dataset.price, Math.max(0, +i.value)); });
      const s = $('#sort', root)?.value; if (s) u.set('sort_by', s);
      return u;
    };

    let ctl;
    const load = async (url, keepFocus) => {
      ctl?.abort(); ctl = new AbortController();
      root.classList.add('is-loading');
      try {
        const r = await fetch(DROP.withParam(url, 'section_id', sid), { signal: ctl.signal });
        if (!r.ok) throw r.status;
        const fresh = $('[data-shop]', DROP.parse(await r.text())); if (!fresh) throw 0;
        const focusKey = keepFocus && document.activeElement?.closest('#fbody') ? (document.activeElement.dataset.vals || document.activeElement.dataset.price || document.activeElement.id) : null;
        ['.tb', '#active', '#grid', '#more'].forEach(sel => { const a = $(sel, root), b = $(sel, fresh); if (a && b) a.replaceWith(b); });
        const fb = $('#fbody', root), nb = $('#fbody', fresh); if (fb && nb) fb.innerHTML = nb.innerHTML;
        const fa = $('#fapply', root), na = $('#fapply', fresh); if (fa && na) fa.textContent = na.textContent;
        const fc = $('#fclear', root), nc = $('#fclear', fresh); if (fc && nc) fc.dataset.url = nc.dataset.url;
        const clean = new URL(url, location.origin); clean.searchParams.delete('section_id');
        history.replaceState(null, '', clean.pathname + clean.search);
        if (focusKey) $$('#fbody input', root).find(i => (i.dataset.vals || i.dataset.price || i.id) === focusKey)?.focus({ preventScroll: true });
        pages = 1;
        afterRender();
      } catch (e) { if (e?.name !== 'AbortError') location.href = url; }
      finally { root.classList.remove('is-loading'); }
    };
    const apply = keepFocus => { const q = params().toString(); load(pageBase + (q ? '?' + q : ''), keepFocus); };

    let pT;
    root.addEventListener('change', e => {
      const t = e.target;
      if (t.id === 'f-hg') {
        const eg = JSON.parse(t.dataset.eg || '[]');
        $$('[data-param="filter.p.vendor"]', root).forEach(b => { if (JSON.parse(b.dataset.vals).some(v => eg.includes(v))) b.checked = t.checked; });
        apply(true); return;
      }
      if (t.matches('#fbody input[data-vals]')) { apply(true); return; }
      if (t.id === 'sort') { apply(false); return; }
      if (t.matches('#fbody input[data-price]')) { clearTimeout(pT); apply(true); }
    });
    root.addEventListener('input', e => { if (e.target.matches('#fbody input[data-price]')) { clearTimeout(pT); pT = setTimeout(() => apply(true), 600); } });
    root.addEventListener('submit', e => { if (e.target.id === 'fbody') { e.preventDefault(); apply(true); } });
    root.addEventListener('click', async e => {
      const pill = e.target.closest('#active button[data-url], #fclear');
      if (pill) { e.preventDefault(); load(pill.dataset.url); return; }
      const chip = e.target.closest('#active button[data-vals]');
      if (chip) {
        e.preventDefault();
        const vals = JSON.parse(chip.dataset.vals);
        $$(`#fbody input[data-param="${chip.dataset.param}"]`, root).forEach(i => { if (JSON.parse(i.dataset.vals).some(v => vals.includes(v))) i.checked = false; });
        apply(false); return;
      }
      const more = e.target.closest('#loadmore');
      if (more) { e.preventDefault(); loadMore(more); }
    });

    /* load more: append the next page; remember how many pages were open for Back */
    const pagesKey = () => 'drop-pages:' + location.pathname + location.search;
    let pages = 1;
    const loadMore = async btn => {
      if (btn.dataset.busy) return; btn.dataset.busy = 1;
      try {
        const r = await fetch(DROP.withParam(btn.dataset.next, 'section_id', sid));
        const fresh = $('[data-shop]', DROP.parse(await r.text())); if (!fresh) return;
        const grid = $('#grid', root);
        $$('#grid > .card', fresh).forEach(c => grid.appendChild(c));
        $('#more', root).replaceWith($('#more', fresh));
        pages++; DROP.motion(grid);
      } finally { delete btn.dataset.busy; }
    };
    addEventListener('pagehide', () => { try { sessionStorage.setItem(pagesKey(), JSON.stringify({ pages, y: scrollY })); } catch (e) { } });
    const restore = async () => {
      let saved; try { saved = JSON.parse(sessionStorage.getItem(pagesKey()) || 'null'); sessionStorage.removeItem(pagesKey()); } catch (e) { }
      if (!saved) return;
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      for (let i = 1; i < saved.pages; i++) { const b = $('#loadmore', root); if (!b) break; await loadMore(b); }
      setTimeout(() => scrollTo(0, saved.y), 0);
    };

    /* grid density (desktop only) */
    const setCols = n => {
      const grid = $('#grid', root); if (!grid) return;
      grid.style.setProperty('--cols', n);
      $$('.dens button', root).forEach(b => b.setAttribute('aria-pressed', +b.dataset.cols === n));
      try { localStorage.setItem('drop-cols', n); } catch (e) { }
    };
    root.addEventListener('click', e => { const b = e.target.closest('.dens button'); if (b) setCols(+b.dataset.cols); });
    const applyCols = () => { if (innerWidth <= 700) return; let n = 4; try { n = +localStorage.getItem('drop-cols') || 4; } catch (e) { } setCols(n); };

    const afterRender = () => { sortSizes(); syncHg(); syncSize(); applyCols(); DROP.motion(root); };
    afterRender();
    restore();
  };

  const boot = () => $$('[data-shop]').forEach(init);
  boot();
  document.addEventListener('drop:section', e => $$('[data-shop]', e.detail).forEach(init));
})();
